module.exports = __webpack_public_path__ + "img/close.d682077c.svg";